/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkCreateSystemUserItemRequest
 */
export interface BulkCreateSystemUserItemRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkCreateSystemUserItemRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BulkCreateSystemUserItemRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BulkCreateSystemUserItemRequest
     */
    dreNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BulkCreateSystemUserItemRequest
     */
    email: string;
}

/**
 * Check if a given object implements the BulkCreateSystemUserItemRequest interface.
 */
export function instanceOfBulkCreateSystemUserItemRequest(value: object): value is BulkCreateSystemUserItemRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('dreNumber' in value) || value['dreNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function BulkCreateSystemUserItemRequestFromJSON(json: any): BulkCreateSystemUserItemRequest {
    return BulkCreateSystemUserItemRequestFromJSONTyped(json, false);
}

export function BulkCreateSystemUserItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreateSystemUserItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'dreNumber': json['dreNumber'],
        'email': json['email'],
    };
}

export function BulkCreateSystemUserItemRequestToJSON(json: any): BulkCreateSystemUserItemRequest {
    return BulkCreateSystemUserItemRequestToJSONTyped(json, false);
}

export function BulkCreateSystemUserItemRequestToJSONTyped(value?: BulkCreateSystemUserItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'dreNumber': value['dreNumber'],
        'email': value['email'],
    };
}

